import { Link as RouterLink } from 'react-router-dom';

import { superstyled } from '@zenbusiness/zui/styles';

export const Link = superstyled({
  name: 'Widget',
  slot: 'Link',
  tag: RouterLink,
  styles: ({ theme }) => ({
    color: theme.palette.text.tertiary,
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    fontSize: '1rem',
    fontWeight: 'bold',
    lineHeight: '1.75rem',
    gap: '0.5rem',
    height: 'max-content',
    textDecoration: 'none',

    [theme.breakpoints.up('md')]: {
      marginBlockStart: '0.25rem',
    },
  }),
});
